export const categories = [
  {
    id: "po文技巧",
    slug: "tips",
    name: "Po文技巧",
    description: "掌握撰写热门po文的实用技巧，从标题到内容全面优化",
    icon: "ri-lightbulb-line",
    articleCount: 15,
  },
  {
    id: "po文排版",
    slug: "formatting",
    name: "Po文排版",
    description: "专业的po文排版方法，让内容更具可读性和视觉吸引力",
    icon: "ri-text-wrap",
    articleCount: 10,
  },
  {
    id: "po文范例",
    slug: "examples",
    name: "Po文范例",
    description: "精选优质po文范例，学习顶级创作者的写作思路",
    icon: "ri-file-list-3-line",
    articleCount: 12,
  },
  {
    id: "最佳发布时机",
    slug: "timing",
    name: "最佳发布时机",
    description: "分析各平台最佳发布时间，最大化po文曝光与互动",
    icon: "ri-time-line",
    articleCount: 8,
  },
  {
    id: "互动率提升",
    slug: "engagement",
    name: "互动率提升",
    description: "提高po文互动率的策略方法，让粉丝主动参与讨论",
    icon: "ri-chat-1-line",
    articleCount: 14,
  },
  {
    id: "平台攻略",
    slug: "platforms",
    name: "平台攻略",
    description: "针对不同社交平台的po文策略，精准触达目标受众",
    icon: "ri-smartphone-line",
    articleCount: 9,
  },
];